import { Component, createContext } from 'react'
import { $, getError } from 'utils'
import Redirect from 'react-router-dom/Redirect'


export const { Provider, Consumer } = createContext()
export const withConsumer = (BaseComponent, redirect) => {
  return class extends Component {
    render() {
      const { data } = this.props
      return (
        $(Consumer, null,
          context => {
          if (data && data.error) {
            context.setErrorMessage(getError(data.error))
            if (redirect === '/persons') {
              return null
            }
            if (redirect !== 'noRedirect') {
              return $(Redirect, {to: redirect || '/'})
            }
          }
          return $(BaseComponent, {...context, ...this.props, ...this.state})
        }
        )
      )
    }
  }
}



// WEBPACK FOOTER //
// ./src/store.js